import React from 'react';
import IconArrowRight from 'cccisd-icons/arrow-right20';
import IconArrowDown from 'cccisd-icons/arrow-down20';
import style from './accordionStyle.css';

export default props => {
    return (
        <div>
            <div className={style.header} onClick={() => props.handleCollapse(props.id)}>
                {props.collapsed ? <IconArrowRight spaceRight /> : <IconArrowDown spaceRight />}
                <span className={style.headerText}>{props.title}</span>
            </div>
            {!props.collapsed && <div className={style.content}>{props.children}</div>}
        </div>
    );
};
